import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from "amazon-cognito-identity-js"
import { Config, CognitoIdentityCredentials } from "aws-sdk"
import axios from "axios"

export default class Cognito {
  configure(config) {
    if (config.userPool) {
      this.userPool = config.userPool
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
        Storage: config.Storage
      })
    }
    Config.region = config.region
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId,
    })
    this.options = config
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito
      }
    })

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito
          this._cognito.configure(options)
        }
      }
    })
  }

  /**
   * username, passwordでサインアップ
   * username = emailとしてUserAttributeにも登録
   */
  signUp(userId,name, password) {
    
    const dataEmail = { Name: "email", Value: userId }
    const dataName = {Name:"name",Value:name}
    const attributeList = []
    attributeList.push(new CognitoUserAttribute(dataEmail))
    attributeList.push(new CognitoUserAttribute(dataName))
    return new Promise((resolve, reject) => {
      this.userPool.signUp(
        //campanyId,
        userId,
        password,
        attributeList,
        null,
        (err, result) => {
          if (err) {
            reject(err)
          } else {
            resolve(result)
          }
        }
      )
    })
  }

  /**
   * 確認コードからユーザーを有効化する
   */
  confirmation(userId, confirmationCode) {
    const userData = { Username: userId, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData,)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  /**
   * username, passwordでログイン
   */
  login(userId, password,) {
    const userData = { Username: userId, Pool: this.userPool, Storage: sessionStorage}
    const cognitoUser = new CognitoUser(userData)
    const authenticationData = { UserId: userId, Password: password ,Storage: sessionStorage}
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          // 実際にはクレデンシャルなどをここで取得する(今回は省略)
          axios({
            method: 'post',
            url: 'https://7wafd79vv8.execute-api.ap-northeast-1.amazonaws.com/default/cognitoTest',
            data:{},
            headers:{"Authorization":result.getIdToken().getJwtToken()}
          })
          .then(function(response) {
            sessionStorage.setItem('Authorization', result.getIdToken().getJwtToken())
            console.log(response)
          })
          .catch(function(error) {
            console.log(error)
          })
          resolve(result)
        },
        onFailure: err => {
          alert("IDかパスワードが違います。")
          reject(err)
        }
      })
    })
  }

  /**
   * ログアウト
   */
  logout() {
    this.userPool.getCurrentUser().signOut()
    sessionStorage.clear()
  }

  /**
   * ログインしているかの判定
   */
  isAuthenticated() {
    const cognitoUser = this.userPool.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (cognitoUser === null) {
        reject(cognitoUser)
      }
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        } else {
          if (!session.isValid()) {
            reject(session)
          } else {
            resolve(session)
          }
        }
      })
    })
  }
//トークン取得処理
  getCurrentUserIdToken()  {
    const cognitoUser = this.userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          alert(err);
          return
          } else {
          return session.getIdToken().getJwtToken()
          }
        })
    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
  }
  getUserAttribute = function(){
    let currentUserData = {}
    const cognitoUser = this.userPool.getCurrentUser()
    if (cognitoUser != null) {
        cognitoUser.getSession(function(err, session) {
            if (err) {
                console.log(err)
                alert(err)
            } else {
                cognitoUser.getUserAttributes(function(err, result) {
                    if (err) {
                       console.log(err)
                       alert(err)
                    }
                    for (var i = 0; i < result.length; i++) {
                        currentUserData[result[i].getName()] = result[i].getValue();
                    }
                    sessionStorage.setItem('userName', currentUserData["name"])
                    //console.log(currentUserData["name"])
                })
            }
        })
    }
  } 
}



// WEBPACK FOOTER //
// ./src/cognito/cognito.js